import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAsK7F5fRNtLhXoaR-AuC1YHG6aYnGM5KA",
  authDomain: "goldensea-conciergerie.firebaseapp.com",
  projectId: "goldensea-conciergerie",
  storageBucket: "goldensea-conciergerie.firebasestorage.app",
  messagingSenderId: "1029401596497",
  appId: "1:1029401596497:web:a4cd63e8d191ec13175e70",
};

// Singleton pattern - avoid re-initializing
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

export const db = getFirestore(app);
export const auth = getAuth(app);
export default app;
